import z from 'zod';
import { assetGroupRef, userRef, zoneRef, scopedEntity, locale, pointGeometry, string, datetime, longString, assetRef, } from '../common';
import { staticResponderRelation } from './staticResponder';
export var AssetPropertiesOwnership;
(function (AssetPropertiesOwnership) {
    AssetPropertiesOwnership["Override"] = "override";
    AssetPropertiesOwnership["Inherit"] = "inherit";
})(AssetPropertiesOwnership || (AssetPropertiesOwnership = {}));
export var AppMode;
(function (AppMode) {
    AppMode["Off"] = "off";
    AppMode["On"] = "on";
    AppMode["Risk"] = "risk";
})(AppMode || (AppMode = {}));
export var AssetType;
(function (AssetType) {
    AssetType["Default"] = "default";
    AssetType["Kiosk"] = "kiosk";
})(AssetType || (AssetType = {}));
export const appProperties = z.object({
    mode: z.nativeEnum(AppMode),
});
export const assetProperties = z.object({
    phoneNumber: string.nullish(),
    smsNumber: string.nullish(),
    email: string.nullish(),
    locale: locale.nullish(),
    image: string.nullish(),
});
export const asset = z.object({
    ...scopedEntity.shape,
    user: userRef.nullable(),
    name: string,
    externalId: string.nullish(),
    propertiesOwnership: z.nativeEnum(AssetPropertiesOwnership).optional(),
    properties: assetProperties.default({}),
    position: pointGeometry.nullable().default(null),
    available: z.boolean(),
    allowContactOnOwnAlarms: z.boolean().default(true),
    app: appProperties.nullish(),
    insideZones: zoneRef.array(),
    assetGroups: assetGroupRef.array(),
    staticResponders: staticResponderRelation.array().default([]),
    lastObservationAt: datetime.optional(),
    invisibleResponder: z.boolean().default(false),
    description: longString.optional(),
    type: z.nativeEnum(AssetType).optional(),
});
export const assetRefWithSubset = z.object({
    ...assetRef.shape,
    ...asset.pick({
        customer: true,
        user: true,
        name: true,
        externalId: true,
        properties: true,
        position: true,
        available: true,
        app: true,
        insideZones: true,
        staticResponders: true,
        type: true,
        updatedAt: true,
    }).shape,
});
